export default () => ({
  animated: false,

  init() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animated = true;
            this.animateSteps();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 },
    );

    observer.observe(this.$root);
  },

  animateSteps() {
    const steps = this.$root.querySelectorAll(".wp-block-venn-step");

    steps.forEach((step, index) => {
      setTimeout(() => {
        const stepNumber = step.querySelector(".steps-number");
        const richText = step.querySelector(".rich-text");
        
        if (stepNumber) {
          stepNumber.classList.add("steps-number-active");
        }
        if (richText) {
          richText.classList.add("rich-text-active");
        }
      }, index * 560);
    });
  },
});
